import React, { lazy } from "react";
import { Route, Routes } from "react-router";

import routes from "../../system/routes";
import { authService } from "../../services";
import { loginConstants } from "../../constants";
import { SCREEN_IDS, getItemFromStorage } from "../../system";
import { FlowContainer, isManagerOrGroupAdmin } from "../../shared";
import { viewPathConstants } from "../../constants/global.constants";
import { customerSurveyUrl } from "../../views/shared-screens/constants";

const Login = lazy(() => import("../../views/login/login"));
const ResetPassword = lazy(() => import("../../views/login/resetPassword"));
const CustomerSurvey = lazy(() =>
  import("../../views/shared-screens/views/customerSurvey/customerSurvey")
);
const EmailVerification = lazy(() =>
  import("../../views/emailVerification/emailVerification")
);
const SurveySidebarContainer = lazy(() =>
  import("../../shared/components/sidebarContainer/sidebarContainer")
);
const HubSidebarContainer = lazy(() =>
  import("../../shared/components/sidebarContainer/hubSidebarContainer")
);
const ChangeSurveyPreferences = lazy(() =>
  import(
    "../../views/shared-screens/views/changeSurveyPreferences/changeSurveyPreferences"
  )
);

// Public pages for signed-out users, role-allowed pages for signed-in users.
const AppRoutes = ({ isAuthenticated, isHubMode }) => {
  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/" exact element={<Login />} />
        <Route path={viewPathConstants.LOGIN} exact element={<Login />} />
        <Route path={viewPathConstants.STORES} element={<Login />} />
        <Route
          path={viewPathConstants.REDIRECTING_TO_STORE_PROFILE}
          element={<Login />}
        />
        <Route
          path={`${customerSurveyUrl + viewPathConstants.CUSTOMER_SURVEY}`}
          exact
          element={<CustomerSurvey />}
        />
        <Route
          path={viewPathConstants.EMAIL_VERIFICATION}
          exact
          element={<EmailVerification />}
        />
        <Route
          path={viewPathConstants.CONFIRM_PASSWORD}
          exact
          element={<ResetPassword />}
        />
        <Route
          path={viewPathConstants.CHANGE_SURVEY_PREFERENCES}
          exact
          element={<ChangeSurveyPreferences />}
        />
      </Routes>
    );
  }

  const userRole = getItemFromStorage(loginConstants.ROLE);
  const SidebarContainer = isHubMode
    ? HubSidebarContainer
    : SurveySidebarContainer;

  // Managers and group admins never see admin-only pages.
  const allowedRoutes = isManagerOrGroupAdmin()
    ? routes.filter((route) => !route.adminOnly)
    : routes;

  return (
    <Routes>
      {allowedRoutes.map((prop) => {
        return prop.screenId === SCREEN_IDS.BRANDS ||
          prop.screenId === SCREEN_IDS.BRANDS_LOCATIONS ||
          prop.screenId === SCREEN_IDS.GROUP ? (
          <Route
            key={prop.path}
            path={prop.path}
            element={
              <SidebarContainer
                Element={prop.component}
                screenType={prop.screenId}
                role={userRole}
                logout={authService.logout}
                displayName={prop.displayName}
              />
            }
          />
        ) : (
          <Route
            key={prop.path}
            path={prop.path}
            element={<FlowContainer Element={prop.component} />}
          />
        );
      })}
    </Routes>
  );
};

export default AppRoutes;
